module.exports = __webpack_public_path__ + "static/media/welcome.13277e80.svg";